import React from 'react'
import {style} from 'glamor'
import * as colors from '../colors'

export default (props) => (
  <span
    {...style({
      // fontSize: '2rem',
      display: 'inline-block',
      // textTransform: 'uppercase',
      letterSpacing: '0.2rem'
    })}
    {...props}
  >
    <span>
      Buy
    </span>
    <span
    {...style({
      fontWeight: 'bold',
      display: 'inline-block',
      // color: colors.yellow
      // border: `2px solid ${colors.yellow}`,
      // padding: '0.25rem 0.5rem',
    })}
    >
      ideas
    </span>
  </span>

)



/** WEBPACK FOOTER **
 ** ./src/components/Logo.js
 **/